import { RootState } from "redux/reducers/rootReducer";
import { createSelector } from "reselect";

const getReservationState = (state: RootState) => state.reservation;

export const getReservationStatus = createSelector(
  [getReservationState],
  (state) => state.status
);

export const getCartId = createSelector(
  [getReservationState],
  (state) => state.cartId
);

export const getPendingMenuItem = createSelector(
  [getReservationState],
  (state) => state.pendingMenuItem
);

export const getCartItemCount = createSelector(
  [getReservationState],
  (state) => state?.cart?.cartItems?.length
);

export const getStaleCartDispensaryInformation = createSelector(
  [getReservationState],
  (state) => state.cart?.dispensary
);
